module.exports = __webpack_public_path__ + "static/media/background06.368a2d87.jpg";